import actions from "@state/actions"
import { Dispatch } from "redux";
import * as types from "./types"

export const requestAccess = (dispatch: Dispatch, designAccess: types.IRequestAccess) => {
  return new Promise((resolve, reject) => {
    dispatch(actions.designs.requestAccess(designAccess, (result, error) => {
      if (error) reject(error);
      else resolve(result);
    }));
  })
}

export const createFromTemplate = (dispatch: Dispatch, designRequest: types.ICreateFromTemplate) => {
  return new Promise((resolve, reject) => {
    dispatch(actions.designs.createFromTemplate(designRequest, (result, error) => {
      if (error) reject(error);
      else resolve(result);
    }));
  });
}

export const findDefaultName = (items: types.IDesign[]) => {
  var prevMaxNumber: number = -1;
  items.map(item => {
    const splittedItem = item.name.split(" ");
    if (splittedItem && splittedItem.length === 2) {
      if (parseInt(splittedItem[1]) > prevMaxNumber) {
        prevMaxNumber = parseInt(splittedItem[1]);
      }
    }
  })
  return `Untitled ${prevMaxNumber + 1}`;
}